import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const PasswordValidationList = ({ errorState }) => {
  if (!errorState?.length) return null;
  return (
    <ul className="password-validate-list">
      {errorState?.map((error, index) => (
        <li className="password-validate-list-item" key={`error-item-${index}`}>
          <FaCheckCircle
            className={error?.isError ? "validate-error" : "validate-success"}
          />
          <span className="text-break">{error?.message}</span>
        </li>
      ))}
    </ul>
  );
};

export default PasswordValidationList;
